//Set 100% True Height
window.addEventListener("load", function () {
  let trueHeight = window.innerHeight;
  let trueHeightsHeader =  trueHeight - 48;

  let setHeights = document.querySelectorAll('.true-height');
  setHeights.forEach(function(item,i){
    item.style.height = trueHeight + "px";
    //checkHome();
  });

  let mobileHeights = document.querySelectorAll('.mobile-hero');
  mobileHeights.forEach(function(item,i){
    item.style.height = trueHeightsHeader + "px";
    //checkHome();
  });

  let setHeightsHeader = document.querySelectorAll('.true-height-header');

  if(setHeightsHeader){
    setHeightsHeader.forEach(function(item,i){
      item.style.height = trueHeightsHeader + "px";
    });
  }

  let windowHeight= document.querySelectorAll('.window-height');
  if(windowHeight){
    windowHeight.forEach(function(item,i){
      item.style.height = trueHeight + "px";
    });
  }
});

window.addEventListener("resize", function(){
  //console.log('resize');
  let trueHeight = window.innerHeight;
  let trueHeightsHeader =  trueHeight - 48;

  let setHeights = document.querySelectorAll(".true-height");

  setHeights.forEach(function(item,i){
    item.style.height = trueHeight + "px";
    //checkHome();
  });

  let windowHeight= document.querySelectorAll('.window-height');
  if(windowHeight){
    windowHeight.forEach(function(item,i){
      item.style.height = trueHeight + "px";
    });
  }

});

//Cart
let cartBtn = document.querySelectorAll('.cart-btn');
let blurCon = document.querySelector('body');

cartBtn.forEach(function(item,i){
  item.addEventListener('click',function(event){
    event.preventDefault();
    sideCart.classList.add('active');
    blurCon.classList.add('blur');
  });
});

let closeCartBtn = document.querySelectorAll('.close-cart-btn');
let sideCart = document.querySelector('#side-cart');

closeCartBtn.forEach(function(item,i){
  item.addEventListener('click',function(event){
    event.preventDefault();
    sideCart.classList.remove('active');
    blurCon.classList.remove('blur');
  });
});

let closeCartSideBtn = document.querySelectorAll('.close-cart-side-btn');
closeCartSideBtn.forEach(function(item,i){
  item.addEventListener('click',function(event){
    event.preventDefault();
    sideCart.classList.remove('active');
    blurCon.classList.remove('blur');
  });
});

//Top Navigation
let topNavBtn = document.querySelectorAll('.top-nav-btn');
let topNav = document.querySelector('.top-nav');

topNavBtn.forEach(function(item,i){
  item.addEventListener('click',function(event){
    event.preventDefault();
    topNav.classList.toggle('open');
    blurCon.classList.add('blur');
  });
});

let closeTopNavBtn = document.querySelectorAll('.close-top-nav-btn');

closeTopNavBtn.forEach(function(item,i){
  item.addEventListener('click',function(event){
    event.preventDefault();
    topNav.classList.remove('open');
    blurCon.classList.remove('blur');
  });
});

//Close Remove Screen
let closeRemoveScreen = document.querySelector('.close-remove-btn');
if(closeRemoveScreen){
  closeRemoveScreen.addEventListener('click',function(event){
    event.preventDefault();
    document.querySelector('#confirm-remove').classList.remove('active');
    document.querySelector('body').classList.remove('blur');
    document.querySelector('body').classList.remove('remove-blur');
  });
}

let cancelRemoveBtn = document.querySelector('.cancel-remove-btn');

if(cancelRemoveBtn){
  cancelRemoveBtn.addEventListener('click',function(event){
    event.preventDefault();
    document.querySelector('#confirm-remove').classList.remove('active');
    document.querySelector('body').classList.remove('blur');
    document.querySelector('body').classList.remove('remove-blur');
  });
}

//Contact
let contactPop = document.querySelector('#contact-popup');
let contactBtn = document.querySelectorAll('.contact-btn');
let closeContactBtn = document.querySelectorAll('.close-contact-btn');

contactBtn.forEach(function(item,i){
  item.addEventListener('click',function(event){
    event.preventDefault();
    contactPop.classList.add('active');
    blurCon.classList.add('blur');
  });
});

closeContactBtn.forEach(function(item,i){
  item.addEventListener('click',function(event){
    event.preventDefault();
    contactPop.classList.remove('active');
    blurCon.classList.remove('blur');
  });
});

window.addEventListener("resize", function(){
  setSideContactWidth();
});

let setSideContactWidth = function(){
  let contactWidth = window.innerWidth;
  let contactInnerWidth = contactPop.querySelector('.right').offsetWidth;
  let contactSideWidth = contactWidth - contactInnerWidth;
  document.querySelector('#left-close-contact').style.width = contactSideWidth + "px";
}

setSideContactWidth();

//Mobile Nav Button
let menuBtn = document.querySelectorAll('.menu-btn');

menuBtn.forEach(function(item,i){
  item.addEventListener('click',function(event){
    event.preventDefault();
    topNav.classList.toggle('open');
    blurCon.classList.add('blur');
  });
});

//Mobile Close Button
let closeMobileBtn = document.querySelectorAll('.mobile-close-btn');

closeMobileBtn.forEach(function(item,i){
  item.addEventListener('click',function(event){
    event.preventDefault();
    topNav.classList.remove('open');
    blurCon.classList.remove('blur');
  });
});

//Search
let searchBtn = document.querySelectorAll('.search-btn');
let sideSearch = document.querySelector('#side-search');
let closeSearchBtn = document.querySelectorAll('.close-search-side-btn');
let searchCheck = document.querySelector('.search-pg');
let searchInput = document.querySelector('#search-input');
let seaarchResults = document.querySelector('#search-results');

if(searchCheck == null){
  console.log("Not on search page");
  searchBtn.forEach(function(item,i){
    item.addEventListener('click',function(event){
      event.preventDefault();
      sideSearch.classList.add('active');
      blurCon.classList.add('blur');
      searchInput.focus();
      searchInput.classList.add('toggle');
    });
  });

  closeSearchBtn.forEach(function(item,i){
    item.addEventListener('click',function(event){
      event.preventDefault();
      sideSearch.classList.remove('active');
      blurCon.classList.remove('blur');
      searchInput.classList.remove('toggle');
      searchInput.value = '';
      seaarchResults.innerHTML = '';
    });
  });
} else {
  searchBtn.forEach(function(item,i){
    item.addEventListener('click',function(event){
      event.preventDefault();
      document.querySelector('.search-input').focus();
    });
  });
  window.addEventListener("load", function () {
    document.querySelector('.search-right .bottom-links').classList.add('show');
  });
}

//Newsletter
//Cookies.set('newsletter', 'false');
let newsCookie = Cookies.get('newsletter');
//console.log(newsCookie);
let homePage = document.querySelector('.home-pg');

if(newsCookie == false || newsCookie == undefined || newsCookie == null || newsCookie == 'false'){
  if(homePage){
    setTimeout(() => {
      //console.log('Delay ended.');
      document.querySelector('#newsletter-footer').classList.add('active');
    }, 45000);
  } else {
    document.querySelector('#newsletter-footer').classList.add('active');
  }
} else {
  if(homePage == null){
    document.querySelector('#newsletter-footer').classList.add('active');
  }
}

let openNewsBtn = document.querySelectorAll('.newsletter-btn');
openNewsBtn.forEach(function(item,i){
  item.addEventListener('click',function(event){
    event.preventDefault();
    document.querySelector('#newsletter-footer').classList.add('active');
    window.scrollTo(0, document.body.scrollHeight);
  });
});

let closeNewsBtn = document.querySelector('.close-news-btn');

closeNewsBtn.addEventListener('click', function(event){
  event.preventDefault();
  document.querySelector('#newsletter-footer').classList.remove('active');
  Cookies.set('newsletter', 'true', {expires: 7});
});

//Header Hide
let lastScrollTop = 0; // Variable to store the last scroll position
let firstScrollHandled = false; // Flag to indicate if the first scroll event has been handled
let header = document.querySelector('header'); // The element you want to show/hide

// Function to handle the scroll event
function handleScroll() {
  let currentScroll = window.pageYOffset || document.documentElement.scrollTop;

  let banner = document.querySelector('.banner-active');

  // Only add or remove the 'hidden' class after the first user-initiated scroll
  if (firstScrollHandled) {
    // Check if the user is scrolling down
    if (currentScroll > lastScrollTop) {
      // Hide the element
      header.classList.add('hidden');
      if(banner){
        
      }
    } else {
      // Show the element
      header.classList.remove('hidden');
      if(banner){
        
      }
    }
  } else {
    firstScrollHandled = true; // Mark that the first scroll event has been handled
  }

  // Update the last scroll position to the current scroll position
  lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
}

// Listen for scroll events
window.addEventListener('scroll', handleScroll, false);

// Ensure the header is visible on initial page load
header.classList.remove('hidden');

//Bottom logo
let bottomLogo = document.querySelector('.bottom-logo');

if(bottomLogo){

  gsap.registerPlugin(ScrollTrigger);

  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  window.addEventListener('load', debounce(function() {
      gsap.to('.bottom-logo', {
        scrollTrigger: {
          trigger: '.logo-trigger',
          start: 'top bottom',
          //end: 'bottom top',
          end: 'bottom -=800',
          //markers: true,
          toggleClass: {targets: bottomLogo, className: 'sticky'},
        }
      });
  }, 250)); // 250 milliseconds of no-scroll threshold before fade-out triggers


}

let banner = document.querySelector('.banner-active');

if(banner) {
  gsap.registerPlugin(ScrollTrigger);

  ScrollTrigger.create({
    trigger: "main",
    start: "top top",
    end: "bottom top",
    onEnter: () => document.querySelector('.jk-banner').classList.add("banner-hidden"),
    onLeaveBack: () => document.querySelector('.jk-banner').classList.remove("banner-hidden"),
  });
}

let measurePop = document.querySelector('.measure-pop');

//Measure Pop
if(measurePop){
  let openMeasureBtn = document.querySelectorAll('.measure-btn');
  openMeasureBtn.forEach(function(item,i){
    item.addEventListener('click',function(event){
      event.preventDefault();
      measurePop.classList.add('active');
      blurCon.classList.add('blur');
    });
  });

  let closeMeasureBtn = document.querySelector('.close-measure-btn');
  closeMeasureBtn.addEventListener('click',function(event){
    event.preventDefault();
    measurePop.classList.remove('active');
    blurCon.classList.remove('blur');
  });
}